import { saveDataInStorage, parsedDataInStorage } from '../../utils/Storage/storageFunctions';

export default function updateUserData(updateData) {
  const currentData = parsedDataInStorage();
  if (!currentData) return;
  const updatedData = { ...currentData, ...updateData };
  saveDataInStorage(updatedData);
}
